<template>
	<v-layout row wrap class="step-one" v-cloak>
		<v-flex xs12>
			<v-card class="fill-height scroll-card">
				<div class="quote-builder__card-inner inner-scroll">
					<v-card-title class="pt-0">
						<h3
							class="subheading font-weight-bold secondary--text"
						>STEP 1: Select a product below to get started.</h3>
					</v-card-title>

					<v-card-text>
						<v-layout wrap>
							<v-flex xs12 sm6 md3 v-for="category in categories" :key="category.name">
								<v-card hover class="fill-height" @click="selectCategory(category.slug)">
									<v-img :src="category.photo_url" aspect-ratio="1.25"
											contain
											style="background-color: #00529c;"
									 ></v-img>
									<v-card-title class="justify-center">
										<h3 class="text-sm-center title mb-0">{{category.name}}</h3>
									</v-card-title>
									<v-card-actions class="pa-3 justify-center">
										<v-btn
											color="primary"
											v-text="number !== 'create' ? 'Add to Quote' : 'Start Quote'"
										>Start Quote</v-btn>
									</v-card-actions>
								</v-card>
							</v-flex>
						</v-layout>
					</v-card-text>
				</div>
			</v-card>
		</v-flex>
		<!-- <code>{{categories}}</code>
		<code>{{products}}</code>-->
	</v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Errors from "@root/helpers/Errors";
var { mainRoutes } = require("@root/mixins");

export default {
	mixins: [mainRoutes],

	data() {
		return {
			proposal_date: null,
			send_reminder_on: null,
			name: "",
			errors: new Errors()
		};
	},

	props: {
		number: {
			default: "create"
		}
	},

	computed: {
		...mapGetters("products", ["categories", "products"]),

		...mapGetters("documents", {
			CURRENT_DOCUMENT: "currentDocument"
		})
	},

	methods: {
		...mapActions("documents", {
			POST_DOCUMENT: "postDocument",
			UPDATE_DOCUMENT: "updateDocument"
		}),

		selectCategory(slug) {
			if (this.number === "create") {
				this.createDocument(slug);
			} else {
				this.updateDocument(slug);
			}
		},

		createDocument(slug) {
			this.$swal({
				title: "Start New Quote",
				text: "Enter a Quote Name to start a new quote.",
				// type: "warning",
				input: "text",
				inputPlaceholder: "Quote Name",
				showCloseButton: true,
				inputValidator: value => {
					return new Promise(resolve => {
						if (!value) {
							resolve("Quote Name is required.");
						} else if(value.length > 150) {
							resolve("Quote Name cannot be longer than 150 characters.");
						} else {
							resolve();
						}
					});
				},

				showCancelButton: true,
				confirmButtonText: "Start Quote"
			}).then(result => {
				if (result.value) {
					this.POST_DOCUMENT({
						// proposal_date: this.proposal_date,
						// send_reminder_on: this.send_reminder_on,
						name: result.value
					}).then(data => {
						this.nextStep(2, this.CURRENT_DOCUMENT(data.number), {
							category: slug
						});
					});
				}
			});

			// return;
		},

		updateDocument(slug) {
			this.nextStep(2, this.CURRENT_DOCUMENT(this.number), {
				category: slug
			});
		}
	},

	created() {
		this.name = this.document.name;

		if (this.document.proposal_date) {
			this.proposal_date = this.document.proposal_date;
		} else {
			this.proposal_date = new Date();
		}

		if (this.send_reminder_on) {
			this.send_reminder_on = this.document.send_reminder_on;
		} else {
			this.send_reminder_on = new Date();
			this.send_reminder_on.setDate(this.send_reminder_on.getDate() + 7);
		}
	}
};
</script>

